import React, { useCallback, useRef, useState, useEffect } from "react";
import { useTheme } from "../../../../../../../hooks/WebCheckinUsers/theme";
import ButtonWebCheckinUser from "../../../../../../../components/ButtonWebCheckinUser/index";
import { ArrowRightIcon } from "../../../../../../../components/SvgComponents/Icons/ArrowRightIcon";
import SignaturePad, { SignaturePadRef } from './SignaturePad';
import { StepReservationSteps, useGlobalWebCheckinUser } from "../../../../../../../hooks/WebCheckinUsers/global";
import { CgArrowLeft } from "react-icons/cg";
import { inactiveItens } from "../../../../../../../theme";
import { rem, Tabs, TextInput } from "@mantine/core";
import { GoPencil } from "react-icons/go";
import { TbKeyboard, TbTrash } from "react-icons/tb";
import { NameInput, SignatureCanvasWrapper, SignatureDisplay, SignatureHeader, SignatureLabel, SignatureLine } from "./style";
import { IGroupProps } from "../../../../../../../interfaces";
import { GenericFormWebCheckinUser, IGenericFormRefProps } from "../../../../../components/GenericForm";
import { useForm } from "react-hook-form";
import Signature from "../../../../../../../assets/signature.svg";
import { IContractModel } from "../../../../interfaces";

interface ISignContractStepProps {
  onNext: (data: { contract: IContractModel }) => void;
  goBack: () => void;
  guestName: string;
  loading: boolean;
}

function generateSignatureFromText(text: string): string {
  console.log("text", text);
  const canvas = document.createElement('canvas');
  canvas.width = 400;
  canvas.height = 160;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.font = '28px Dancing Script, cursive';
  ctx.fillStyle = '#000';
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  ctx.fillText(text, canvas.width / 2, canvas.height / 2);
  return canvas.toDataURL('image/png');
}

export const SignContractStep: React.FC<ISignContractStepProps> = ({
  onNext,
  goBack,
  guestName,
  loading,
}) => {
  const { colorsTheme } = useTheme();
  const { contractModel, setContractModel, getSetReservationStep } = useGlobalWebCheckinUser()

  const [activeTab, setActiveTab] = useState<string>('write');
  const [typedName, setTypedName] = useState(guestName);
  const [signatureError, setSignatureError] = useState<string | null>(null);
  const signaturePadRef = useRef<SignaturePadRef>(null);

  const {
    register,
    control,
    watch,
    formState: { errors },
    setValue,
    trigger,
  } = useForm({
    defaultValues: {
      name: guestName,
    },
  });

  const form_ref = useRef<IGenericFormRefProps>(null);
  const _form = watch();

  const handleNext = useCallback(() => {
    setSignatureError(null);
    // @ts-ignore
    let signature = null;

    if (activeTab === 'draw') {
      signature = signaturePadRef.current?.getSignature() || null;
      if (!signature) {
        setSignatureError('Por favor, desenhe sua assinatura antes de continuar.');
        return;
      }
    } else {
      const nameToSign = _form?.name || guestName;
      if (!nameToSign) {
        setSignatureError('Por favor, escreva seu nome para a assinatura.');
        return;
      }
      signature = generateSignatureFromText(nameToSign);
    }

    setContractModel({
      ...contractModel,
      signature,
      signed_at: new Date()
    });
    onNext({
      contract: {
        ...contractModel,
        signature,
        signed_at: new Date()
      }
    });
  }, [contractModel, onNext, activeTab, _form?.name, guestName]);

  const handleClearSignature = () => {
    signaturePadRef.current?.clear();
  }

  const groups: IGroupProps[] = [
    {
      name: "",
      label: "",
      fields: [
        [
          {
            name: "name",
            label: "Nome completo do titular",
            type: "input",
            required: true,
            noUpperCase: true,
            getIsDisabled: (data: any) => activeTab === 'draw',
          },
        ],
      ],
    },
  ];

  useEffect(() => {
    setTypedName(_form?.name);
  }, [_form?.name]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={goBack}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Assinar contrato</div>
            <div
              style={{ position: "absolute", right: 0 }}
            >
              <div style={{ color: "#8D8D8D", fontSize: 12 }}>{getSetReservationStep(StepReservationSteps.SignContract)}</div>
            </div>
          </div>
        </div>

        <div style={{ marginBottom: 16, fontSize: 20, fontWeight: 700 }}>Manuscrito</div>

        <GenericFormWebCheckinUser
          ref={form_ref}
          groups={groups}
          _form={_form}
          control={control as any}
          errors={errors}
          trigger={trigger}
          setValue={setValue as any}
          register={register}
          noTrigger
          containerStyle={{ width: "100%" }}
        />

        <Tabs value={activeTab} onTabChange={(value) => setActiveTab(value || 'write')} variant="pills  " radius="md" styles={(theme) => ({
          root: {
            marginTop: rem(1),
          },
          tab: {
            ...theme.fn.focusStyles(),
            backgroundColor: 'transparent',
            color: '#717171',
            border: '1px solid transparent',
            cursor: 'pointer',
            fontSize: theme.fontSizes.sm,
            display: 'flex',
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 600,

            '&:disabled': {
              opacity: 0.5,
              cursor: 'not-allowed',
            },

            '&:hover': {
              backgroundColor: 'transparent',
              color: '#000000',
            },

            '&[data-active]': {
              backgroundColor: 'transparent',
              color: '#000000',
              '&:hover': {
                backgroundColor: 'transparent',
                color: '#000000',
              },
              '&:after': {
                content: '""',
                position: 'absolute',
                bottom: rem(4),
                left: '50%',
                top: '110%',
                transform: 'translateX(-50%)',
                width: 'calc(60% - 16px)',
                height: '2px',
                backgroundColor: colorsTheme.secondary.light,
              },
            },
          },

          tabIcon: {
            marginRight: theme.spacing.xs,
            display: 'flex',
            alignItems: 'center',
          },

          tabsList: {
            position: 'relative',
          },
        })}
        >
          <Tabs.List grow>
            <Tabs.Tab value="write" icon={<TbKeyboard size="1.4rem" />}>Escrever</Tabs.Tab>
            <Tabs.Tab value="draw" icon={<GoPencil size="1.2rem" />}>Desenhar</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="write" pt="md" style={{ marginTop: rem(4) }}>
            <SignatureDisplay>{typedName}</SignatureDisplay>
          </Tabs.Panel>

          <Tabs.Panel value="draw" pt="md" style={{ marginTop: rem(4) }}>
            <SignatureCanvasWrapper>
              <SignatureHeader>
                <SignatureLabel>
                  <img src={Signature} alt="signature" />
                  <span role="img" aria-label="signature"></span> Desenhe sua <b style={{ fontWeight: 700 }}>assinatura</b>
                </SignatureLabel>

                <ButtonWebCheckinUser
                  background={'transparent'}
                  color={"#292929"}
                  style={{ marginTop: 0, width: "auto", display: 'flex', fontSize: 14, fontWeight: 700, alignItems: 'center', gap: 4 }}
                  onClick={handleClearSignature}
                >
                  <TbTrash size={18} /> Limpar
                </ButtonWebCheckinUser>
              </SignatureHeader>

              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                <SignaturePad ref={signaturePadRef} height={160} />
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: -37 }}>
                <SignatureLine />
              </div>
            </SignatureCanvasWrapper>
          </Tabs.Panel>
        </Tabs>

        {signatureError && (
          <div style={{ color: 'red', marginTop: 8, textAlign: 'center' }}>{signatureError}</div>
        )}
      </div>

      {!loading && (
        <ButtonWebCheckinUser
          background={colorsTheme.secondary.light}
          color={"#292929"}
          style={{ marginTop: 30 }}
          onClick={handleNext}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flex: 1,
              padding: "0px 10px",
              alignItems: 'center'
            }}
          >
            Assinar contrato
            <ArrowRightIcon />
          </div>
        </ButtonWebCheckinUser>
      )}
    </div>
  );
};
